import "./app/zod-config";
import "@mantine/core/styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { createApp } from "./app/create-app";

const container = document.getElementById("root");
if (container === null) throw new Error("index.html has no #root element");

const { queryClient, router } = createApp();

createRoot(container).render(
  <StrictMode>
    <App queryClient={queryClient} router={router} />
  </StrictMode>,
);
